/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './team-group-item-page.component.html';

import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {TeamGroupModel} from './team-group-api.service';
import {AdminResourcePagesModule} from '../../common/controller/admin-resource-pages.module';
import {TeamGroupAnalysisPageComponent} from './team-group-analysis-page.component';
import {TeamGroupEditPageComponent} from './team-group-edit-page.component';

@Component({
  standalone: true,
  imports: [AdminResourcePagesModule, TeamGroupAnalysisPageComponent, TeamGroupEditPageComponent],
  selector: 'adn-team-group-item-page',
  template
})
export class TeamGroupItemPageComponent {
  @Input() state: SignalAdminResourcePageState<TeamGroupModel>;
}
